import React from 'react';

import {GridViewButtonSet} from './GridViewButtonSet.jsx';
var defaultImg = require("../default.json")

var GridViewImage = React.createClass({
    showPreview: function(user, slug){
      this.props.showPreview(user, slug);
    },
    editTheme: function(slug, accountSlug, type){
      this.props.editTheme(slug, accountSlug, type);
    },
  	render: function(){
  		var img = "";
  		if(!(this.props.value["thumbnail_image"]) || this.props.value["thumbnail_image"] == "null"){
  			img = <img src={defaultImg.GRID_IMAGE} alt="" title="" className="img-responsive" local/> ;
  		}
  		else{
  			img = <img src={this.props.value["thumbnail_image"]} alt="" title="" className="img-responsive"/>;
  		}
    	return(
          	<figure className="theme-grid__img"> {img}
          	<div className="theme-grid--overlay"></div>
               <GridViewButtonSet value = {this.props.value}
                                  showPreview= {this.showPreview}
                                  editTheme = {this.editTheme}
                                  libName = {this.props.libName}
                                  showPreviwButton = {this.props.showPreviwButton}
                                  active = {this.props.active} />
          	</figure>
      	);
  	}
});

export {GridViewImage};



/** WEBPACK FOOTER **
 ** ./html/components/GridViewImage.jsx
 **/